<template>
  <b-col sm="6" lg="4" class="custom-button info-box" @click="startIntroFromOverview">
    <div class="button-box shadow">
      <div class="button-box-body">
        <div class="infotour-icon"></div>
      </div>
      <div class="button-legend">Rundgang starten</div>
    </div>
  </b-col>
</template>

<script>
  export default {
    data: () => ({
      isIntroDisplayed: false
    }),
    methods: {
      startIntroFromOverview () {
        this.$intro().setOptions({
          keyboardNavigation: true,
          exitOnOverlayClick: false,
          skipLabel: 'Rundgang beenden',
          doneLabel: 'Rundgang beenden',
          prevLabel: 'Zurück',
          nextLabel: 'Weiter'
        })
          .start()
          .oncomplete(() => {
            this.updateIntroDisplayedStatus()
          })
          .onexit(() => {
            this.updateIntroDisplayedStatus()
          })
      },
      async updateIntroDisplayedStatus () {
        this.$store.dispatch('intro/UPDATE_INTRO_DISPLAYED').then(res => {
          const { errors } = res

          if (errors) {
            console.error(errors)
          }
          this.introStatus = res.data.userSetIntroDisplayed.ok
        }).catch(err => {
          console.error(err)
        })
      }
    }
  }
</script>

<style lang="scss" >
  .info-box{
    margin-top: 0;

    @include media-breakpoint-down(xs) {
      display: none;
    }

    @include media-breakpoint-down(md) {
      display: none;
    }
  }

  .infotour-icon {
      width: 40px;
      height: 40px;
      background: assets('info_icon.svg') no-repeat top left;
    }
</style>
